

import { useNavigate, useParams } from "react-router-dom";
import { Box, Grid, IconButton, Typography } from "@mui/material";
import { iconos } from "../../data";
import { useInventarioXID } from "../../hooks/cache";




export const LayoutInvetrario = ({ children, titulo }) => {


    const navigate = useNavigate();
    const { id } = useParams();
    const { data } = useInventarioXID(id);  


    return (
        <>
        <Box sx={{ mb:3 }}>
            <Grid container direction='row' alignItems='center'>
                <Box flex={1} />
                
                <Typography variant='h2' sx={{ fontWeight: 600 }}>
                    {titulo}
                </Typography>
                
                <Box flex={1} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <IconButton onClick={() => navigate(-1)} sx={{ color:'#fff', backgroundColor:'secondary.main'}}>
                        {iconos['back']}
                    </IconButton>
                </Box>
            </Grid>
            
            <Grid container justifyContent='center'>
                <Typography sx={{ color:'text.secondary', fontSize:'1rem', fontWeight:300, 
                    letterSpacing:'0.5px', opacity:0.7, mt:0.5,textAlign:'center'
                }}>
                    {(data) ? `Inventario de ${data.nombre}` : 'Cargando Información...'}
                </Typography>
            </Grid>
        </Box>

        <Grid container alignItems='center' justifyContent='center'>
            {children}
        </Grid>
        </>
    )
}